import type {MigrationInterface, QueryRunner} from "typeorm";

export class AddStatsMaxspeedColumn1738000000000 implements MigrationInterface {
  name = "AddStatsMaxspeedColumn1738000000000";

  async up(queryRunner: QueryRunner): Promise<void> {
    await queryRunner.query(`ALTER TABLE "user" ADD COLUMN "Stats-Maxspeed" float`);
  }

  async down(queryRunner: QueryRunner): Promise<void> {
    await queryRunner.query(`ALTER TABLE "user" DROP COLUMN "Stats-Maxspeed"`);
  }
}
